module.exports = __webpack_public_path__ + "img/clickbait.ea3a85e3.svg";